"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalCompartilhar = exports.CompartilhamentoTipo = void 0;
var react_1 = __importStar(require("react"));
var Botao_1 = require("../Botao/Botao");
var Cores_1 = require("../Cores/Cores");
var Icone_1 = require("../Icone/Icone");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Titulo_1 = require("../Tipografia/Titulo/Titulo");
var Divider_1 = require("../Divider/Divider");
var EmailCompartilhar_1 = require("./EmailCompartilhar/EmailCompartilhar");
var WhatsAppCompartilhar_1 = require("./WhatsAppCompartilhar/WhatsAppCompartilhar");
var Modal_1 = require("../Modal/Modal");
var listaCodigoInternacionalTelefone_1 = require("../Inputs/InputTelefone/InputDdi/listaCodigoInternacionalTelefone");
var InputArquivo_1 = require("../Inputs/InputArquivo/InputArquivo");
var HelperText_1 = require("../HelperText/HelperText");
var globalMu_1 = __importDefault(require("../../globalMu"));
var estiloCompartilhar = require("./ModalCompartilhar.module.scss");
var converterParaBase64 = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            var base64String = reader.result.split(",")[1];
            resolve(base64String);
        };
        reader.onerror = reject;
    });
};
var CompartilhamentoTipo;
(function (CompartilhamentoTipo) {
    CompartilhamentoTipo[CompartilhamentoTipo["WHATSAPP"] = 1] = "WHATSAPP";
    CompartilhamentoTipo[CompartilhamentoTipo["EMAIL"] = 2] = "EMAIL";
})(CompartilhamentoTipo || (exports.CompartilhamentoTipo = CompartilhamentoTipo = {}));
var ModalCompartilhar = function (_a) {
    var _b;
    var isOpen = _a.isOpen, _c = _a.multiplosAnexos, multiplosAnexos = _c === void 0 ? false : _c, _d = _a.bloqueado, bloqueado = _d === void 0 ? true : _d, quantidadeMaximaDestinatarios = _a.quantidadeMaximaDestinatarios, extensaoArquivo = _a.extensaoArquivo, anexoExibido = _a.anexoExibido, whatsAppDesabilitado = _a.whatsAppDesabilitado, onClose = _a.onClose, onEnviar = _a.onEnviar;
    //region States
    var _e = (0, react_1.useState)(""), mensagem = _e[0], setMensagem = _e[1];
    var _f = (0, react_1.useState)(false), emailAtivo = _f[0], setEmailAtivo = _f[1];
    var _g = (0, react_1.useState)(""), email = _g[0], setEmail = _g[1];
    var _h = (0, react_1.useState)([]), listaEmails = _h[0], setListaEmails = _h[1];
    var _j = (0, react_1.useState)(false), whatsAppAtivo = _j[0], setWhatsAppAtivo = _j[1];
    var _k = (0, react_1.useState)((_b = listaCodigoInternacionalTelefone_1.listaCodigoInternacionalTelefone.find(function (item) { return item.country === "Brasil"; })) !== null && _b !== void 0 ? _b : null), ddi = _k[0], SetDdi = _k[1];
    var _l = (0, react_1.useState)(""), telefone = _l[0], setTelefone = _l[1];
    var _m = (0, react_1.useState)([]), listaTelefone = _m[0], setListaTelefone = _m[1];
    var _o = (0, react_1.useState)({ erro: false, mensagem: "" }), erro = _o[0], setErro = _o[1];
    var _p = (0, react_1.useState)(undefined), conteudoAjudaEmail = _p[0], setConteudoAjudaEmail = _p[1];
    var _q = (0, react_1.useState)(undefined), conteudoAjudaWhatsApp = _q[0], setConteudoAjudaWhatsApp = _q[1];
    var _r = (0, react_1.useState)(false), contatoRepetidoTelefone = _r[0], setContatoRepetidoTelefone = _r[1];
    //region Handler Email
    var handleClickEmail = function () {
        setEmailAtivo(function (prev) { return !prev; });
        setWhatsAppAtivo(false);
    };
    var handleEditEmail = function (emailSelecionado) {
        var novaListaEmails = listaEmails.filter(function (email) { return email !== emailSelecionado; });
        setConteudoAjudaEmail(undefined);
        setEmail(emailSelecionado);
        setListaEmails(novaListaEmails);
    };
    var handleChangeEmail = function (email) {
        setEmail(email !== null && email !== void 0 ? email : "");
        setConteudoAjudaEmail(undefined);
    };
    var handleRemoveEmail = function (emailToRemove) {
        setListaEmails(listaEmails.filter(function (email) { return email !== emailToRemove; }));
    };
    var handleAddEmail = function () {
        if (globalMu_1.default.isNullOrEmptyOrUndefined(email) && listaEmails.length <= 0)
            return setConteudoAjudaEmail({ estado: "error", texto: "Insira um e-mail.", icone: "warning" });
        if (quantidadeMaximaDestinatarios && listaEmails.length >= quantidadeMaximaDestinatarios) {
            return setConteudoAjudaEmail({
                estado: "error",
                texto: "Número máximo de destinatários adicionado.",
                icone: "warning"
            });
        }
        setConteudoAjudaWhatsApp(undefined);
        var emailRegex = /^(?=.{1,254}$)(?=.{1,64}@)([a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        var erro = emailRegex.test(email);
        if (erro === false)
            return;
        if (listaEmails.includes(email)) {
            return setConteudoAjudaEmail({ estado: "error", texto: "E-mail já inserido.", icone: "warning" });
        }
        setConteudoAjudaEmail(undefined);
        setListaEmails(__spreadArray(__spreadArray([], listaEmails, true), [email], false));
        setEmail("");
    };
    //#region Handler WhatsApp
    var handleClickWhatsApp = function () {
        setWhatsAppAtivo(function (prev) { return !prev; });
        setEmailAtivo(false);
    };
    var handleEditWhatsapp = function (telefoneSelecionado) {
        var ddiTelefone = telefoneSelecionado.ddi;
        var numeroTelefone = telefoneSelecionado.numeroSemDdi;
        var getDdi = listaCodigoInternacionalTelefone_1.listaCodigoInternacionalTelefone.find(function (item) { return item.dialCode === ddiTelefone; });
        setTelefone(numeroTelefone);
        SetDdi(getDdi !== null && getDdi !== void 0 ? getDdi : null);
        setListaTelefone(listaTelefone.filter(function (telefone) { return telefone.numeroCompleto !== telefoneSelecionado.numeroCompleto; }));
    };
    var handleChangeDdi = function (paisSelecionado) {
        if (paisSelecionado && !Array.isArray(paisSelecionado)) {
            SetDdi(paisSelecionado);
        }
        else {
            SetDdi(null);
        }
    };
    var handleChangeTelefone = function (telefoneInput) {
        setTelefone(telefoneInput ? telefoneInput : "");
    };
    var onAdicionarTelefone = function () {
        var _a;
        if (quantidadeMaximaDestinatarios && listaTelefone.length >= quantidadeMaximaDestinatarios) {
            return setConteudoAjudaWhatsApp({
                estado: "error",
                texto: "Número máximo de destinatários adicionado.",
                icone: "warning"
            });
        }
        setConteudoAjudaWhatsApp(undefined);
        if (telefone === "" && (ddi === null || ddi === void 0 ? void 0 : ddi.dialCode) === "")
            return setConteudoAjudaWhatsApp({ estado: "error", texto: "Insira o campo telefone corretamente.", icone: "warning" });
        setConteudoAjudaWhatsApp(undefined);
        var telefoneCompleto = "".concat(ddi === null || ddi === void 0 ? void 0 : ddi.dialCode).concat(telefone);
        var numeroInvalido = false;
        if ((ddi === null || ddi === void 0 ? void 0 : ddi.dialCode) === "55" || globalMu_1.default.isNullOrEmptyOrUndefined(ddi === null || ddi === void 0 ? void 0 : ddi.dialCode))
            numeroInvalido = !globalMu_1.default.validarTelefone(telefoneCompleto);
        else
            numeroInvalido = telefone.length < 5 || telefone.length > 15;
        setConteudoAjudaWhatsApp({ texto: "Telefone inválido.", estado: "error", icone: "warning" });
        setConteudoAjudaWhatsApp(undefined);
        if (numeroInvalido)
            return;
        //window.alert("Telefone inválido. Insira um telefone válido.");
        if (listaTelefone.some(function (telefoneObj) { return telefoneObj.numeroCompleto === telefoneCompleto; })) {
            setContatoRepetidoTelefone(true);
            return;
        }
        var novoTelefone = {
            ddi: (_a = ddi === null || ddi === void 0 ? void 0 : ddi.dialCode) !== null && _a !== void 0 ? _a : "",
            numeroCompleto: telefoneCompleto,
            numeroSemDdi: telefone
        };
        setContatoRepetidoTelefone(false);
        setListaTelefone(__spreadArray(__spreadArray([], listaTelefone, true), [novoTelefone], false));
        setTelefone("");
    };
    var handleRemoveTelefone = function (telefoneToRemove) {
        setListaTelefone(listaTelefone.filter(function (telefone) { return telefone.numeroCompleto !== telefoneToRemove; }));
    };
    var handleMensagem = function (mensagem) {
        setMensagem(mensagem !== null && mensagem !== void 0 ? mensagem : "");
        console.log(mensagem);
    };
    var desabilitado = emailAtivo ? false : whatsAppAtivo ? false : true;
    //region renderEmail
    var renderEmail = (react_1.default.createElement(EmailCompartilhar_1.EmailCompartilhar, { valor: email, listaEmails: listaEmails, corpoMensagem: mensagem, conteudoAjudaEmail: conteudoAjudaEmail, onAddEmail: handleAddEmail, onRemoveEmail: handleRemoveEmail, onChangeEmail: handleChangeEmail, onChangeMensagem: handleMensagem, onSelectEmail: handleEditEmail, quantidadeMaximaEmails: quantidadeMaximaDestinatarios }));
    //region renderWhatsApp
    var renderWhatsApp = (react_1.default.createElement(WhatsAppCompartilhar_1.WhatsAppCompartilhar, { internacional: (ddi === null || ddi === void 0 ? void 0 : ddi.dialCode) != "55" && globalMu_1.default.isNotNullOrEmptyOrUndefined(ddi === null || ddi === void 0 ? void 0 : ddi.dialCode), quantidadeMaximaTelefones: quantidadeMaximaDestinatarios, valorDdi: ddi, valorTelefone: telefone, mensagem: mensagem, conteudoAjudaWhatsApp: contatoRepetidoTelefone === true ? { texto: "Telefone já inserido.", estado: "error", icone: "warning" } : conteudoAjudaWhatsApp, onChangeDdi: handleChangeDdi, onChangeTelefone: handleChangeTelefone, onChangeMensagem: handleMensagem, onAdicionarTelefone: onAdicionarTelefone, onRemoveTelefone: handleRemoveTelefone, onSelectTelefone: handleEditWhatsapp, listaTelefone: listaTelefone }));
    //region Principal
    var renderHeader = (react_1.default.createElement("div", { className: estiloCompartilhar.header },
        react_1.default.createElement(Titulo_1.Titulo, { tipo: "cabecalho3", negrito: true, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, conteudo: "Compartilhar por" }),
        react_1.default.createElement("div", { onClick: function () { return onClose(); }, onKeyDown: function (e) {
                if (e.key === "Escape") {
                    onClose();
                }
            }, style: { cursor: 'pointer' }, tabIndex: 0 },
            react_1.default.createElement(Icone_1.Icone, { nome: "close" }))));
    var renderBotaoAplicativo = (react_1.default.createElement("div", { className: estiloCompartilhar.botoesCompartilhar },
        react_1.default.createElement(Botao_1.Botao, { tamanho: "small", estilo: emailAtivo ? "primaryDark" : "outlined", onClick: handleClickEmail },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Icone_1.Icone, { nome: "alternate_email", altura: "1rem", largura: "1rem", cor: emailAtivo ? Cores_1.Cores.GradacaoNeutros.BrancoMU50 : Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }),
                react_1.default.createElement(Corpo_1.Corpo, { tipo: "button2", negrito: 700, cor: emailAtivo ? Cores_1.Cores.GradacaoNeutros.BrancoMU50 : Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }, "E-mail"))),
        react_1.default.createElement(Botao_1.Botao, { tamanho: "small", estilo: whatsAppAtivo ? "primaryDark" : "outlined", onClick: handleClickWhatsApp, desabilitado: whatsAppDesabilitado, title: "Dispon\u00EDvel em breve", style: {
                cursor: whatsAppDesabilitado ? 'not-allowed' : 'pointer',
                border: "1px solid ".concat(Cores_1.Cores.GradacaoNeutros.CinzaFillMU300),
            } },
            react_1.default.createElement(Icone_1.Icone, { nome: "whatsapp", altura: "1rem", largura: "1rem", cor: !whatsAppDesabilitado ? whatsAppAtivo ? Cores_1.Cores.GradacaoNeutros.BrancoMU50 : Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 : Cores_1.Cores.GradacaoNeutros.CinzaFillMU300 }),
            react_1.default.createElement(Corpo_1.Corpo, { style: { cursor: whatsAppDesabilitado ? 'not-allowed' : 'pointer' }, tipo: "button2", negrito: 700, cor: !whatsAppDesabilitado ? whatsAppAtivo ? Cores_1.Cores.GradacaoNeutros.BrancoMU50 : Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 : Cores_1.Cores.GradacaoNeutros.CinzaFillMU300 }, "WhatsApp"))));
    //region Anexo
    var renderAnexo = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InputArquivo_1.InputArquivo, { id: "anexo", desabilitado: bloqueado, readonly: true, multiplosAnexos: multiplosAnexos, anexos: anexoExibido, extensaoArquivo: extensaoArquivo, style: { width: "fit-content" } })));
    //region Ações
    var montarAnexos = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resultados, _i, _a, anexo, base64;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    resultados = [];
                    _i = 0, _a = anexoExibido !== null && anexoExibido !== void 0 ? anexoExibido : [];
                    _b.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 4];
                    anexo = _a[_i];
                    return [4 /*yield*/, converterParaBase64(anexo)];
                case 2:
                    base64 = _b.sent();
                    resultados.push({ anexo: anexo, anexoBase64: base64, nomeArquivo: anexo.name });
                    _b.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, resultados];
            }
        });
    }); };
    var handleEnviar = function () { return __awaiter(void 0, void 0, void 0, function () {
        var anexosConvertidos, dados, dados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((whatsAppAtivo && listaTelefone.length === 0) ||
                        (emailAtivo && listaEmails.length === 0)) {
                        setErro({ erro: true, mensagem: "Preencha todos os campos corretamente." });
                        if (emailAtivo && listaEmails.length <= 0) {
                            setConteudoAjudaEmail({ estado: "error", texto: "Insira um e-mail.", icone: "warning" });
                        }
                        return [2 /*return*/];
                    }
                    else {
                        setErro({ erro: false, mensagem: "" });
                    }
                    return [4 /*yield*/, montarAnexos()];
                case 1:
                    anexosConvertidos = _a.sent();
                    if (whatsAppAtivo) {
                        dados = {
                            tipo: CompartilhamentoTipo.WHATSAPP,
                            destinatarios: listaTelefone.map(function (telefone) { return telefone.numeroCompleto; }),
                            mensagem: mensagem,
                            anexos: anexosConvertidos,
                        };
                        onEnviar && onEnviar(dados);
                    }
                    if (emailAtivo) {
                        dados = {
                            tipo: CompartilhamentoTipo.EMAIL,
                            destinatarios: listaEmails,
                            mensagem: mensagem,
                            anexos: anexosConvertidos,
                        };
                        if (listaEmails.length > 0) {
                            setConteudoAjudaEmail(undefined);
                            onEnviar && onEnviar(dados);
                        }
                        else {
                            setConteudoAjudaEmail({ estado: "error", texto: "Insira um e-mail.", icone: "warning" });
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var renderBotoesAcao = (react_1.default.createElement("div", { className: estiloCompartilhar.botoesAcao },
        react_1.default.createElement(Botao_1.Botao, { tamanho: "medium", estilo: "outlined" },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Corpo_1.Corpo, { tipo: "button1", negrito: 700, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, onClick: function () { return onClose(); } }, "Cancelar"))),
        react_1.default.createElement(Botao_1.Botao, { tamanho: "medium", tipoComportamento: "submit", estilo: "primaryDark", desabilitado: desabilitado, style: { cursor: desabilitado ? 'not-allowed' : 'pointer' }, onClick: function () { return handleEnviar(); } },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Corpo_1.Corpo, { tipo: "button1", negrito: 700, cor: desabilitado ? Cores_1.Cores.GradacaoNeutros.CinzaFillMU400 : Cores_1.Cores.GradacaoNeutros.BrancoMU50 }, "Enviar"),
                react_1.default.createElement(Icone_1.Icone, { nome: "send", altura: "1.4rem", largura: "1.4rem", cor: desabilitado ? Cores_1.Cores.GradacaoNeutros.CinzaFillMU400 : Cores_1.Cores.GradacaoNeutros.BrancoMU50 })))));
    //region Return
    return (react_1.default.createElement(Modal_1.Modal, { isOpen: isOpen, onClose: function () { return onClose(); }, corDeFundo: Cores_1.Cores.GradacaoNeutros.BrancoMU50, style: { overflowY: "unset", maxWidth: 'fit-content' } },
        react_1.default.createElement("div", { className: estiloCompartilhar.modal },
            renderHeader,
            renderBotaoAplicativo,
            react_1.default.createElement(Divider_1.Divider, null),
            react_1.default.createElement("div", { className: estiloCompartilhar.container }, emailAtivo ? renderEmail : whatsAppAtivo ? renderWhatsApp : null),
            erro.erro && react_1.default.createElement(HelperText_1.HelperText, { estado: "error", texto: erro.mensagem }),
            renderAnexo,
            anexoExibido && (anexoExibido === null || anexoExibido === void 0 ? void 0 : anexoExibido.length) > 1 && (react_1.default.createElement("ul", { style: { listStyleType: 'none', paddingLeft: '20px', marginTop: '8px' } }, anexoExibido.map(function (anexo, index) { return (react_1.default.createElement("li", { key: index },
                react_1.default.createElement("a", { download: anexo.name, href: window.URL.createObjectURL(new Blob([anexo], { type: anexo.type })), target: "_blank", rel: "noopener noreferrer" },
                    react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline" }, anexo.name)))); }))),
            renderBotoesAcao)));
};
exports.ModalCompartilhar = ModalCompartilhar;
